import { UserI } from '../users/state';
import { ResultsI } from '../state';

export interface SearchPatientI {
  identification?: string;
  identificationType?: string;
}

export interface DoctorI {
  id: number;
  specialization: string;
  userId: number;
  user: UserI;
}

export interface MedicalRecordI {
  id: number;
  userId?: number;
  patientId?: number;
  doctorId?: number;
  doctor: DoctorI;
  consultationDate?: number;
  symptoms: string;
  diagnosis: string;
  prescription: string;
}

export interface PatientI {
  id: number;
  userId: number;
  height?: number;
  weight?: number;
  rh?: string;
  sex?: string;
  gender?: string;
  birthdate?: number;
}

export interface PatientUserI {
  patient?: PatientI;
  user?: UserI;
}

export interface MedicalConsultationsDataI {
  medicalConsultations: MedicalRecordI[];
  patient: PatientI;
}

export interface PatientStateI {
  patientsFinded: ResultsI;
  medicalConsultations: MedicalConsultationsDataI;
  patientUser: PatientUserI;
}

export const state: PatientStateI = {
  patientUser: {
  },
  patientsFinded: {
    total: 0,
    data: [],
    perPage: 0,
    page: 0,
    totalPages: 0,
  },
  medicalConsultations: {
    medicalConsultations: [],
    patient: {
      id: 0,
      userId: 0,
    },
  },
};
